import { render, staticRenderFns } from "./BindMobile.vue?vue&type=template&id=76f981a3&scoped=true&"
import script from "./BindMobile.vue?vue&type=script&lang=js&"
export * from "./BindMobile.vue?vue&type=script&lang=js&"
import style0 from "./BindMobile.vue?vue&type=style&index=0&id=76f981a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f981a3",
  null
  
)

component.options.__file = "BindMobile.vue"
export default component.exports